// Auto-generated from the bedd.dev pricing.html snapshot.
// Internal hrefs rewritten to SPA paths via `.scratch/port-page.py`; nav +
// footer are composed from `marketing-shared/` so all marketing pages stay
// in lock-step. To re-port, drop a fresh snapshot at
// `.scratch/bedd-snapshot/pricing.html` and re-run the build script.

import { navMarkup } from '../marketing-shared/nav';
import { footerMarkup } from '../marketing-shared/footer';

export const markup = `${navMarkup('pricing')}

<!-- ──────────────────────────────────────────────
     PAGE HEADER
─────────────────────────────────────────────── -->
<div class="page-hero">
  <div class="container">
    <div class="page-hero-grid">
      <div>
        <div class="eyebrow hero-anim-eyebrow">Transparent Pricing</div>
        <h1><span class="word">Simple.</span><br><span class="em"><span class="word">No</span> <span class="word">surprises.</span></span></h1>
      </div>
      <div class="page-hero-rhs hero-anim-rhs">
        <p>Whether you're an individual preparing for certification, a practice benchmarking your team, or a recruiter screening candidates — there's a plan built for you.</p>
        <div class="view-toggle" id="view-toggle">
          <button class="view-btn active" data-section="individual">Individual</button>
          <button class="view-btn" data-section="enterprise">Business</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ══════════════════════════════════════════════
     INDIVIDUAL PRICING
══════════════════════════════════════════════ -->
<div id="section-individual">
  <div class="section-wrap">

    <div class="section-divider reveal">
      <span class="section-divider-label">Individual Plans</span>
      <div class="section-divider-line"></div>
      <span class="section-divider-desc">Pay once, access instantly</span>
    </div>

    <!-- Three individual cards -->
    <div class="individual-grid reveal-stagger">

      <!-- Single exam -->
      <div class="price-card">
        <div class="pc-eyebrow slate">Single Exam</div>
        <div class="pc-name">Any Exam,<br>Any Discipline</div>
        <div class="pc-price-row">
          <span class="pc-price">$39</span>
          <span class="pc-price-unit">/ attempt</span>
        </div>
        <hr class="pc-divider">
        <p class="pc-desc">Access any single exam from the full BIMAssess catalogue. Includes your results report, topic breakdown, and certificate on pass.</p>
        <ul class="pc-includes">
          <li>One attempt at any exam</li>
          <li>Instant results + topic breakdown</li>
          <li>Certificate on pass</li>
          <li>Valid for 30 days from purchase</li>
        </ul>
        <a href="/catalogue" data-spa-link class="pc-btn">Browse exams</a>
      </div>

      <!-- Architecture Pack -->
      <div class="price-card accent">
        <div class="pc-eyebrow sand">Architecture Pack</div>
        <div class="pc-name">Full Architecture<br>Pathway</div>
        <div class="pc-price-row">
          <span class="pc-price">$139</span>
          <span class="pc-price-unit">/ 12 months</span>
        </div>
        <hr class="pc-divider">
        <p class="pc-desc">All 8 Architecture exams in one purchase — from Novice through to BIM Champion. Unlimited attempts on each exam for 12 months.</p>
        <ul class="pc-includes">
          <li>All 8 Architecture exams</li>
          <li>Unlimited attempts per exam</li>
          <li>Progress tracked across all levels</li>
          <li>Certificate on pass for each level</li>
          <li>12 months access</li>
          <li>Save 55% vs individual</li>
        </ul>
        <a href="#" class="pc-btn dark">Get the pack</a>
        <div class="pc-note">Most popular for architecture professionals</div>
      </div>

      <!-- Discipline Focused Pack -->
      <div class="price-card sage-acc">
        <div class="pc-eyebrow sage">Discipline Pack</div>
        <div class="pc-name">Any Single<br>Discipline</div>
        <div class="pc-price-row">
          <span class="pc-price">$69</span>
          <span class="pc-price-unit">/ 12 months</span>
        </div>
        <hr class="pc-divider">
        <p class="pc-desc">Novice + Specialist exams for any one chosen discipline — Interior, Mechanical, Electrical, Hydraulic, or Structural. Unlimited attempts for 12 months.</p>
        <ul class="pc-includes">
          <li>Choose one discipline</li>
          <li>Novice + Specialist exams included</li>
          <li>Unlimited attempts per exam</li>
          <li>Certificate on pass</li>
          <li>12 months access</li>
          <li>Save 12% vs individual</li>
        </ul>
        <a href="#" class="pc-btn">Choose discipline</a>
      </div>

    </div>

    <!-- ACP Special -->
    <div class="section-divider reveal">
      <span class="section-divider-label">Special</span>
      <div class="section-divider-line"></div>
      <span class="section-divider-desc">ACP Certification Preparation</span>
    </div>

    <div class="reveal" style="margin-bottom:1rem;">
      <div class="price-card clay-acc" style="padding:2rem 2.5rem;">
        <div class="acp-wide">
          <div>
            <div class="pc-eyebrow clay" style="margin-bottom:8px;">Autodesk Certified Professional</div>
            <div class="pc-name" style="font-size:26px;margin-bottom:12px;">ACP Preparation Exam</div>
            <p class="pc-desc" style="margin-bottom:1rem;">Purpose-built to mirror the official Autodesk Certified Professional exam format, question types, and domain weighting. The most comprehensive assessment on BIMAssess — includes unlimited retakes so you keep going until you're ready.</p>
            <ul class="pc-includes">
              <li>Full ACP domain coverage — Modelling, Documentation, Collaboration, Project Standards, Information Analysis</li>
              <li>Timed exam conditions mirroring the real ACP</li>
              <li>Detailed topic breakdown report per attempt</li>
              <li>Unlimited retakes for 12 months</li>
              <li>BIMAssess pass certificate issued on success</li>
            </ul>
          </div>
          <div class="acp-wide-right">
            <div class="pc-eyebrow clay" style="margin-bottom:8px;display:block;">One-off purchase</div>
            <div class="pc-price" style="font-size:64px;color:var(--ink);">$69</div>
            <div style="font-family:'Space Mono',monospace;font-size:11px;color:var(--muted);margin:8px 0 1.4rem;line-height:1.6;">Unlimited retakes<br>12 months access</div>
            <a href="#" class="pc-btn dark">Begin preparation</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Pack Savings at a glance -->
    <div class="section-divider reveal">
      <span class="section-divider-label">Pack Savings</span>
      <div class="section-divider-line"></div>
      <span class="section-divider-desc">At a glance</span>
    </div>

    <div class="savings-row reveal-stagger">
      <div class="saving-card">
        <div class="saving-left">
          <div class="saving-eyebrow">Architecture Pack</div>
          <div class="saving-name">All 8 Architecture Exams</div>
          <div class="saving-desc">$39 × 8 individually = $312 &nbsp;→&nbsp; Pack saves you $173</div>
        </div>
        <div class="saving-right">
          <div class="saving-price">$139</div>
          <div class="saving-badge">Save 55%</div>
        </div>
      </div>
      <div class="saving-card">
        <div class="saving-left">
          <div class="saving-eyebrow">Discipline Pack</div>
          <div class="saving-name">Novice + Specialist (any discipline)</div>
          <div class="saving-desc">$39 × 2 individually = $78 &nbsp;→&nbsp; Pack saves you $9 per discipline</div>
        </div>
        <div class="saving-right">
          <div class="saving-price">$69</div>
          <div class="saving-badge">Save 12% per discipline</div>
        </div>
      </div>
    </div>

  </div>
</div>


<!-- ══════════════════════════════════════════════
     ENTERPRISE PRICING
══════════════════════════════════════════════ -->
<div id="section-enterprise" style="display:none;">
  <div class="section-wrap">

    <div class="section-divider reveal">
      <span class="section-divider-label">Business Plans</span>
      <div class="section-divider-line"></div>
      <span class="section-divider-desc">Billed annually · Choose your own exams</span>
    </div>

    <div class="ent-intro reveal">
      <strong>How it works:</strong> Choose your plan based on how many tests you need running concurrently. Assign any exam from the full catalogue to each slot — mix Architecture, Discipline Focused, and ACP Preparation freely. When a 12-month test period concludes, that slot reactivates for a new assignment. All plans include team skills reports and gap analysis at no extra cost.
    </div>

    <div class="ent-grid reveal-stagger">

      <!-- Small Practice -->
      <div class="ent-card">
        <div>
          <div class="ent-tier">Small Practice</div>
          <div class="ent-name">Starter</div>
        </div>
        <div class="ent-price-row">
          <span class="ent-price">$499</span>
          <span class="ent-period">/ year</span>
        </div>
        <hr class="ent-divider">
        <div class="ent-allowance">
          <span class="ent-allow-num">25</span>
          <span class="ent-allow-label">attempts per year</span>
        </div>
        <ul class="ent-features">
          <li>Choose any exams from full catalogue</li>
          <li>Team skills report</li>
          <li>Gap analysis summary</li>
          <li>Individual result dashboards</li>
          <li>Admin account management</li>
          <li>Email support</li>
        </ul>
        <a href="#" class="ent-btn">Get started</a>
      </div>

      <!-- Boutique -->
      <div class="ent-card featured">
        <div>
          <div class="ent-tier">Boutique</div>
          <div class="ent-name">Professional</div>
        </div>
        <div class="ent-price-row">
          <span class="ent-price">$999</span>
          <span class="ent-period">/ year</span>
        </div>
        <hr class="ent-divider">
        <div class="ent-allowance">
          <span class="ent-allow-num">60</span>
          <span class="ent-allow-label">attempts per year</span>
        </div>
        <ul class="ent-features">
          <li>Choose any exams from full catalogue</li>
          <li>Team skills report</li>
          <li>Gap analysis summary</li>
          <li>Individual result dashboards</li>
          <li>Candidate screening mode</li>
          <li>Admin account management</li>
          <li>Priority email support</li>
        </ul>
        <a href="#" class="ent-btn">Get started</a>
      </div>

      <!-- Business -->
      <div class="ent-card dark">
        <div>
          <div class="ent-tier">Business</div>
          <div class="ent-name">Unlimited</div>
        </div>
        <div class="ent-price-row">
          <span class="ent-price">$1,799</span>
          <span class="ent-period">/ year</span>
        </div>
        <hr class="ent-divider">
        <div class="ent-allowance">
          <span class="ent-allow-num">∞</span>
          <span class="ent-allow-label">unlimited attempts</span>
        </div>
        <ul class="ent-features">
          <li>Choose any exams from full catalogue</li>
          <li>Team skills report</li>
          <li>Gap analysis summary</li>
          <li>Individual result dashboards</li>
          <li>Candidate screening mode</li>
          <li>Custom exam branding</li>
          <li>Admin account management</li>
          <li>Dedicated account support</li>
          <li>Quarterly benchmark reports</li>
        </ul>
        <a href="#" class="ent-btn">Contact us</a>
      </div>

    </div>

    <!-- Comparison table -->
    <div class="section-divider reveal" style="padding-top:2rem;">
      <span class="section-divider-label">Plan Comparison</span>
      <div class="section-divider-line"></div>
    </div>

    <div style="overflow-x:auto;margin-bottom:1rem;" class="reveal">
      <table class="compare-table">
        <thead>
          <tr>
            <th style="width:34%;">Feature</th>
            <th>Starter</th>
            <th class="col-featured">Professional</th>
            <th>Unlimited</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Annual price</td>
            <td>$499</td>
            <td class="col-featured">$999</td>
            <td>$1,799</td>
          </tr>
          <tr>
            <td>Test access</td>
            <td>1 test</td>
            <td class="col-featured">3 tests</td>
            <td>Unlimited</td>
          </tr>
          <tr>
            <td>Attempts per year</td>
            <td>25</td>
            <td class="col-featured">60</td>
            <td>Unlimited</td>
          </tr>
          <tr>
            <td>Cost per attempt (approx.)</td>
            <td>$19.96</td>
            <td class="col-featured">$16.65</td>
            <td>Unlimited</td>
          </tr>
          <tr>
            <td>Choose any exams from catalogue</td>
            <td><span class="check">✓</span></td>
            <td class="col-featured"><span class="check">✓</span></td>
            <td><span class="check">✓</span></td>
          </tr>
          <tr>
            <td>Team skills report</td>
            <td><span class="check">✓</span></td>
            <td class="col-featured"><span class="check">✓</span></td>
            <td><span class="check">✓</span></td>
          </tr>
          <tr>
            <td>Gap analysis summary</td>
            <td><span class="check">✓</span></td>
            <td class="col-featured"><span class="check">✓</span></td>
            <td><span class="check">✓</span></td>
          </tr>
          <tr>
            <td>Individual result dashboards</td>
            <td><span class="check">✓</span></td>
            <td class="col-featured"><span class="check">✓</span></td>
            <td><span class="check">✓</span></td>
          </tr>
          <tr>
            <td>Candidate screening mode</td>
            <td><span class="dash">–</span></td>
            <td class="col-featured"><span class="check">✓</span></td>
            <td><span class="check">✓</span></td>
          </tr>
          <tr>
            <td>Custom exam branding</td>
            <td><span class="dash">–</span></td>
            <td class="col-featured"><span class="dash">–</span></td>
            <td><span class="check">✓</span></td>
          </tr>
          <tr>
            <td>Quarterly benchmark reports</td>
            <td><span class="dash">–</span></td>
            <td class="col-featured"><span class="dash">–</span></td>
            <td><span class="check">✓</span></td>
          </tr>
          <tr>
            <td>Support</td>
            <td>Email</td>
            <td class="col-featured">Priority email</td>
            <td>Dedicated</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p style="font-family:'Space Mono',monospace;font-size:11px;color:var(--muted);text-align:center;margin-bottom:3rem;" class="reveal">
      All plans billed annually. Need a custom volume or a trial for your team?
      <a href="#" style="color:var(--ink);text-decoration:underline;">Get in touch →</a>
    </p>

  </div>
</div>


<!-- ══════════════════════════════════════════════
     FAQ
══════════════════════════════════════════════ -->
<div class="section-wrap">
  <div class="section-divider reveal">
    <span class="section-divider-label">FAQ</span>
    <div class="section-divider-line"></div>
  </div>

  <div class="faq-grid reveal-stagger">
    <div class="faq-item">
      <div class="faq-q">Can I try a free exam before purchasing?</div>
      <div class="faq-a">Yes — create a free BIMAssess account and access a short sample question set for any exam category before committing to a purchase.</div>
    </div>
    <div class="faq-item">
      <div class="faq-q">What happens if I fail an exam?</div>
      <div class="faq-a">Individual purchases give you one attempt at $39 per exam. Pack and enterprise plans include unlimited retakes — so you can keep practising until you're ready to pass.</div>
    </div>
    <div class="faq-item">
      <div class="faq-q">How do enterprise test credits work?</div>
      <div class="faq-a">Your plan gives you concurrent test access — 1 test (Starter), 3 tests (Professional), or unlimited (Business). Each active test runs for 12 months from assignment. When a test period ends, that slot becomes available again.</div>
    </div>
    <div class="faq-item">
      <div class="faq-q">Can we choose different exams for different staff?</div>
      <div class="faq-a">Absolutely. Business plans let you freely assign any exam from the catalogue to any member — a junior architect takes ARCH-01, your MEP lead takes MEC-02, your hire takes ENT-04.</div>
    </div>
    <div class="faq-item">
      <div class="faq-q">Do unused credits roll over?</div>
      <div class="faq-a">Credits do not roll over at the end of the year, but your plan renews annually with a fresh allowance. Contact us if you need to top up mid-year.</div>
    </div>
    <div class="faq-item">
      <div class="faq-q">Are the exams aligned to Autodesk's official certifications?</div>
      <div class="faq-a">Yes — all BIMAssess exams are mapped against the Autodesk Certified User (ACU) and Autodesk Certified Professional (ACP) exam objectives, built by experienced BIM practitioners.</div>
    </div>
    <div class="faq-item">
      <div class="faq-q">Can recruiters use BIMAssess to screen candidates?</div>
      <div class="faq-a">Yes. Boutique and Business plans include candidate screening mode — send a candidate an exam link, they complete it, and you receive their scored results report before interview.</div>
    </div>
    <div class="faq-item">
      <div class="faq-q">What payment methods are accepted?</div>
      <div class="faq-a">All major credit and debit cards via Stripe. Business annual plans can also be invoiced — contact us to arrange.</div>
    </div>
  </div>

  <!-- CTA Band -->
  <div class="cta-band reveal">
    <div class="cta-left">
      <h2>Ready to assess your<br><span class="em">BIM capability?</span></h2>
      <p>Start with a single exam, build your team's picture, or screen your next hire — BIMAssess gives you the clarity to act with confidence.</p>
    </div>
    <div class="cta-btns">
      <button class="cta-btn-primary">Start for free</button>
      <button class="cta-btn-secondary">Talk to us →</button>
    </div>
  </div>

</div>

<!-- ──────────────────────────────────────────────
     FOOTER
─────────────────────────────────────────────── -->

${footerMarkup()}`;
